import React, { Component } from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Slide,
  Paper,
} from '@material-ui/core';

import Draggable from 'react-draggable';

import { connect } from 'react-redux';

import JSONPretty from 'react-json-pretty';
import 'react-json-pretty/themes/monikai.css';

import VirtualTransactionJsonDuck from '../../../ducks/VirtualTransactionJsonDuck';

function Transition(props) {
  return <Slide direction="down" {...props} />;
}

function PaperComponent(props) {
  return (
    <Draggable>
      <Paper {...props} />
    </Draggable>
  );
}

class VirtualTransactionJsonDialog extends Component {
  render() {
    const { virtualTransaction } = this.props;
    return (
      <Dialog
        open={this.props.open}
        TransitionComponent={Transition}
        PaperComponent={PaperComponent}
        aria-labelledby="Virtual Transaction"
        onClose={this.handleClose}
        maxWidth="md"
        fullWidth={true}
      >
        <DialogTitle id="form-dialog-title">
          Virtual Transaction {virtualTransaction ? virtualTransaction.id : ''}
        </DialogTitle>
        <DialogContent>
          <JSONPretty data={virtualTransaction}></JSONPretty>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleClose} color="default">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  handleClose = () => {
    this.props.hideVirtualTransactionJsonDialog();
  };
}

const mapStateToProps = (state) => {
  return {
    virtualTransaction: state.virtualTransactionJson.virtualTransaction,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    hideVirtualTransactionJsonDialog: () => {
      return dispatch(
        VirtualTransactionJsonDuck.creators.hideVirtualTransactionJsonDialog(),
      );
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(VirtualTransactionJsonDialog);
